<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<form name="editForm" novalidate>
    @if (historyService.selectedStepNumber === stepGroupEnum.LOCATIONS_AND_LOSES) {
        <div>
            @if (tabsToShow && tabsToShow.length > 0) {
                <winde-tabs-nav
                    (tabChanged)="changeTab($event)"
                    [activeTab]="currentTab"
                    [customClass]="'tabs-nav--doc-tabs tabs-nav--map-info-window mt-3 mb-2 font-size-12'"
                    [tabsList]="tabsToShow"
                    [translationParamsMap]="tabsTranslationParams"
                    [translationPrefix]="'project.selectedAreaInfoTabs'"
                    class="mb-2"
                >
                </winde-tabs-nav>
            }
            <!-- ALL -->
            @if (currentTab === areaInfoTabs.ALL) {
                <div>
                    @if (historyService.isEditModeEnabled) {
                        <div>
                            <button
                                (click)="toggleEnable(false)"
                                [disabled]="selectedEnableEntitiesCount === 0"
                                class="btn btn-link btn-sm btn-disable-units font-size-12"
                                id="disableUnit"
                            >
                                Disable selected {{ selectedEnableEntitiesCount > 1 ? 'items' : 'item' }} ({{
                                    selectedEnableEntitiesCount
                                }})
                            </button>
                        </div>
                    }
                    @if (historyService.isEditModeEnabled) {
                        <div>
                            <button
                                (click)="toggleEnable(true)"
                                [disabled]="selectedDisableEntitiesCount === 0"
                                class="btn btn-link btn-sm btn-enable-units font-size-12"
                                id="enableUnit"
                            >
                                Enable selected {{ selectedDisableEntitiesCount > 1 ? 'items' : 'item' }} ({{
                                    selectedDisableEntitiesCount
                                }})
                            </button>
                        </div>
                    }
                    @if (historyService.isEditModeEnabled) {
                        <div>
                            <button
                                (click)="removeAll()"
                                [disabled]="!selectedToRemoveCounter || selectedToRemoveCounter === 0"
                                class="btn btn-link btn-sm btn-link-los font-size-12"
                                id="removeSelected"
                            >
                                Remove selected {{ selectedToRemoveCounter > 1 ? 'items' : 'item' }} ({{ selectedToRemoveCounter }})
                            </button>
                        </div>
                    }
                </div>
            }
            <!-- LOCATIONS -->
            @if (currentTab === areaInfoTabs.LOCATIONS) {
                <div>
                    @if (historyService.isEditModeEnabled && unfrozenNodesSelected) {
                        <div class="d-flex align-items-center mt-2 justify-content-between">
                            <span class="text-nowrap mb-0 mr-1 p-0 font-size-12">{{ 'project.location.blockedByPole' | translate }}: </span>
                            <winde-sui-project-editable-select-component
                                (valueChanged)="setBlockedByPoleAngle($event)"
                                [config]="blockedByPoleControl"
                                class="control-with-label-width"
                            ></winde-sui-project-editable-select-component>
                        </div>
                    }
                    @if (historyService.isEditModeEnabled && showDeviceAzimuthControl) {
                        <div class="d-flex align-items-center mt-2 justify-content-between">
                            <span class="text-nowrap mb-0 mr-1 p-0 font-size-12">{{ 'project.location.deviceAzimuth' | translate }}: </span>
                            <winde-sui-project-editable-select-component
                                (valueChanged)="setDeviceAzimuth($event)"
                                [config]="deviceAzimuthControl"
                                class="control-with-label-width"
                            ></winde-sui-project-editable-select-component>
                        </div>
                    }
                    @if (historyService.isEditModeEnabled && unfrozenNodesSelected) {
                        <div class="d-flex align-items-center mt-2 justify-content-between">
                            <span class="col mb-0 p-0 text-nowrap font-size-12">{{ 'project.location.mhType' | translate }}: </span>
                            <select
                                (change)="changeMHType()"
                                [(ngModel)]="mhType"
                                class="form-control form-control-sm col font-size-12"
                                id="mhType"
                                name="mhType"
                            >
                                @for (typeValue of mhTypeValues; track typeValue) {
                                    <option [ngValue]="typeValue">
                                        {{ '' + typeValue | translateEnum: 'NodeTypeEnum' }}
                                    </option>
                                }
                            </select>
                        </div>
                    }
                    @if (historyService.logicalTopology.layersModeEnabled && layersOptions && unfrozenNodesSelected) {
                        <div class="d-flex align-items-center mt-2 justify-content-between">
                            <span class="col mb-0 p-0 text-nowrap font-size-12">{{ 'project.location.layer' | translate }} : </span>
                            @if (historyService.isEditModeEnabled) {
                                <select
                                    (ngModelChange)="changeLayerIndex($event)"
                                    [ngModel]="layerIndex"
                                    class="form-control form-control-sm col font-size-12"
                                    id="layer"
                                    name="layer"
                                >
                                    @for (layer of layersOptions; track layer) {
                                        <option [ngValue]="layer.key">{{ layer.value }}</option>
                                    }
                                </select>
                            }
                        </div>
                    }
                    @if (historyService.isEditModeEnabled) {
                        <div>
                            <button
                                (click)="createLos()"
                                [disabled]="allowLosStationsCount === 0"
                                class="btn btn-link btn-sm btn-link-los font-size-12"
                                id="createLos"
                            >
                                Create LOS to neighbors ({{ allowLosStationsCount }})
                            </button>
                        </div>
                    }
                    @if (historyService.isEditModeEnabled) {
                        <div>
                            <button
                                (click)="verifyLos()"
                                [disabled]="losToVerifyCount === 0"
                                class="btn btn-link btn-sm btn-link-los font-size-12"
                                id="validateLos"
                            >
                                Validate LOS to neighbors ({{ losToVerifyCount }})
                            </button>
                        </div>
                    }
                    @if (historyService.isEditModeEnabled) {
                        <div>
                            <button
                                (click)="toggleEnable(false, areaInfoTabs.LOCATIONS)"
                                [disabled]="selectedEnableNodes.length === 0"
                                class="btn btn-link btn-sm btn-disable-units font-size-12"
                                id="disableNodes"
                            >
                                Disable selected {{ selectedEnableNodes.length > 1 ? 'locations' : 'location' }} ({{
                                    selectedEnableNodes.length
                                }})
                            </button>
                        </div>
                    }
                    @if (historyService.isEditModeEnabled) {
                        <div>
                            <button
                                (click)="toggleEnable(true, areaInfoTabs.LOCATIONS)"
                                [disabled]="selectedDisableNodes.length === 0"
                                class="btn btn-link btn-sm btn-enable-units font-size-12"
                                id="enableNodes"
                            >
                                Enable selected {{ selectedDisableNodes.length > 1 ? 'locations' : 'location' }} ({{
                                    selectedDisableNodes.length
                                }})
                            </button>
                        </div>
                    }
                    @if (historyService.isEditModeEnabled) {
                        <div>
                            <button
                                (click)="removeAll(areaInfoTabs.LOCATIONS)"
                                [disabled]="!selectedNodesIdToRemove || selectedNodesIdToRemove.length < 1"
                                class="btn btn-link btn-sm btn-link-los font-size-12"
                                id="removeSelectedNodes"
                            >
                                Remove selected {{ selectedNodesIdToRemove.length > 1 ? 'locations' : 'location' }} ({{
                                    selectedNodesIdToRemove.length
                                }})
                            </button>
                        </div>
                    }
                </div>
            }
            <!-- LINK -->
            @if (currentTab === areaInfoTabs.LINKS) {
                <div>
                    @if (!projectStateService.isAreaPlannerProject()) {
                        <div class="form-group row align-items-center mb-2">
                            <span class="col-auto mb-0 font-size-12">{{ 'project.link.type' | translate }} :</span>
                            <div class="col">
                                <select
                                    [(ngModel)]="linkType"
                                    class="form-control form-control-sm font-size-12"
                                    id="linkType"
                                    name="linkType"
                                >
                                    @for (type of linkTypes; track type) {
                                        <option [ngValue]="type">
                                            {{ '' + type | translateEnum: 'TopologyLinkTypeEnum' }}
                                        </option>
                                    }
                                </select>
                            </div>
                        </div>
                        @if (historyService.isEditModeEnabled && freezedLinks && freezedLinks.length > 0) {
                            <div>
                                <button
                                    (click)="toggleFreezeLinks(freezedLinks, false, false)"
                                    [disabled]="freezedLinks.length === 0"
                                    class="btn btn-link btn-sm font-size-12"
                                    id="unfreezeLinks"
                                >
                                    Unfreeze links ({{ freezedLinks.length }})
                                </button>
                            </div>
                        }
                        @if (historyService.isEditModeEnabled && installedLinks && installedLinks.length > 0) {
                            <div>
                                <button
                                    (click)="toggleFreezeLinks(installedLinks, true, false)"
                                    [disabled]="installedLinks.length === 0"
                                    class="btn btn-link btn-sm font-size-12"
                                    id="installedLinks"
                                >
                                    Unmark links as installed ({{ installedLinks.length }})
                                </button>
                            </div>
                        }
                    }
                    @if (historyService.isEditModeEnabled) {
                        <div>
                            <button
                                (click)="toggleEnable(false, areaInfoTabs.LINKS)"
                                [disabled]="selectedEnableLinks.length === 0"
                                class="btn btn-link btn-sm btn-disable-units font-size-12"
                                id="disableLinks"
                            >
                                Disable selected {{ selectedEnableLinks.length > 1 ? 'links' : 'link' }} ({{ selectedEnableLinks.length }})
                            </button>
                        </div>
                    }
                    @if (historyService.isEditModeEnabled) {
                        <div>
                            <button
                                (click)="toggleEnable(true, areaInfoTabs.LINKS)"
                                [disabled]="selectedDisableLinks.length === 0"
                                class="btn btn-link btn-sm btn-enable-units font-size-12"
                                id="enableLinks"
                            >
                                Enable selected {{ selectedDisableLinks.length > 1 ? 'links' : 'link' }} ({{ selectedDisableLinks.length }})
                            </button>
                        </div>
                    }
                    @if (historyService.isEditModeEnabled) {
                        <div>
                            <button
                                (click)="removeAll(areaInfoTabs.LINKS)"
                                [disabled]="!selectedLinksIdToRemove || selectedLinksIdToRemove.length < 1"
                                class="btn btn-link btn-sm btn-link-los font-size-12"
                                id="removeSelectedLinks"
                            >
                                Remove selected {{ selectedLinksIdToRemove.length > 1 ? 'links' : 'link' }} ({{
                                    selectedLinksIdToRemove.length
                                }})
                            </button>
                        </div>
                    }
                </div>
            }
            <!-- POLYGON -->
            <ul class="list-unstyled mb-0">
                <li>
                    @if (showHouseDetectionBtn && historyService.logicalTopology.activeLayerIdx !== WHOLE_TOPOLOGY_LAYER_INDEX) {
                        <button (click)="startHouseDetection()" class="btn btn-link btn-sm btn-house-detection-polygon font-size-12">
                            House detection
                        </button>
                    }
                </li>
                <li>
                    @if (showSavePolygonBtn) {
                        <button (click)="savePolygon()" class="btn btn-link btn-sm btn-save-polygon font-size-12">Save polygon</button>
                    }
                </li>
                <li>
                    @if (showDeletePolygonBtn) {
                        <button (click)="removePolygon()" class="btn btn-link btn-sm btn-remove-polygon font-size-12">
                            Delete polygon
                        </button>
                    }
                </li>
            </ul>
        </div>
    }

    @if (!projectStateService.isAreaPlannerProject()) {
        @if (historyService.selectedStepNumber !== stepGroupEnum.LOCATIONS_AND_LOSES) {
            <div>
                @if (selectedLinksId.length) {
                    <div class="selected-actions">
                        <h6 class="font-size-14" id="selectedLinksNumber">
                            Selected {{ selectedLinksId.length }}
                            {{ selectedLinksId.length > 1 ? 'Links' : 'Link' }}
                        </h6>
                        @if (historyService.isEditModeEnabled && unfreezedLinks) {
                            <div>
                                <button
                                    (click)="toggleFreezeLinks(unfreezedLinks, true, false)"
                                    [disabled]="unfreezedLinks.length === 0"
                                    class="btn btn-link btn-sm font-size-12"
                                    id="freezeLinks"
                                >
                                    Freeze links ({{ unfreezedLinks.length }})
                                </button>
                            </div>
                        }
                        @if (historyService.isEditModeEnabled && freezedLinks && freezedLinks.length > 0) {
                            <div>
                                <button
                                    (click)="toggleFreezeLinks(freezedLinks, false, false)"
                                    [disabled]="freezedLinks.length === 0"
                                    class="btn btn-link btn-sm font-size-12"
                                    id="unfreezeLinks"
                                >
                                    Unfreeze links ({{ freezedLinks.length }})
                                </button>
                            </div>
                        }
                        @if (historyService.isEditModeEnabled && notInstalledLinks) {
                            <div>
                                <button
                                    (click)="toggleFreezeLinks(notInstalledLinks, true, true)"
                                    [disabled]="notInstalledLinks.length === 0"
                                    class="btn btn-link btn-sm font-size-12"
                                    id="unInstalledLinks"
                                >
                                    Mark links as installed ({{ notInstalledLinks.length }})
                                </button>
                            </div>
                        }
                        @if (historyService.isEditModeEnabled && installedLinks && installedLinks.length > 0) {
                            <div>
                                <button
                                    (click)="toggleFreezeLinks(installedLinks, true, false)"
                                    [disabled]="installedLinks.length === 0"
                                    class="btn btn-link btn-sm font-size-12"
                                    id="installedLinks"
                                >
                                    Unmark links as installed ({{ installedLinks.length }})
                                </button>
                            </div>
                        }
                    </div>
                }
            </div>
        }
    }
</form>
